.typeOptions{
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.typeOption{
    width: 280px;
    height: 100px;
    padding: 16px 24px;
    cursor: pointer;
}

.typeOption.selected{
    cursor: unset;
    border-color:#00aeef;
    box-shadow: 0 0 0 1px #00aeef;
}

.typeLabel{
    font-size: 16px;
    color: rgba(0, 0, 0, 0.65);
}

.priceText{
    color: rgba(0, 0, 0, 0.87);
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
}

.listPriceText{
    font-size: 16px;
    margin-right: 8px;
    color: rgba(0, 0, 0, 38%);
    text-decoration: line-through;
}

.monthlyListPriceText{
    font-size: 16px;
    margin-right: 8px;
    color: rgba(0, 0, 0, 38%);
}

.priceTextDiscount{
    font-size: 20px;
    font-weight: 600;
    color: #F2545B;
    vertical-align: middle;
}

@media (max-width: 992px) {
    .typeOption{
        width: 256px;
        height: unset;
        border: none!important;
    }

    .typeLabel{
        font-size: 16px!important;
        font-family: 'Golos Text SemiBold';
    }

    .priceText{
        font-family: 'Golos Text SemiBold';
    }
}